/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ASP.NET 8 Web API for RIGHTIO Booking System - DEVELOPMENT
 * This is the API for the RIGHTIO Booking System, it is used to provide the booking system with data and to update the booking system with data.
 * OpenAPI spec version: v1
 */
import type {
  RightioWBSAPIModelsAccountCodes,
  RightioWBSAPIModelsAccountCodesInput,
  RightioWBSAPIModelsAddressBlacklist,
  RightioWBSAPIModelsApplicationSettings,
  RightioWBSAPIModelsCallMapping,
  RightioWBSAPIModelsCallMappingInput,
  RightioWBSAPIModelsCallTypeGroups,
  RightioWBSAPIModelsCallTypes,
  RightioWBSAPIModelsCalls,
  RightioWBSAPIModelsCallsInput,
  RightioWBSAPIModelsCallsPatchInput,
  RightioWBSAPIModelsCharges,
  RightioWBSAPIModelsChargingTableAccountCodes,
  RightioWBSAPIModelsChargingTableAccountTypes,
  RightioWBSAPIModelsChargingTableBase,
  RightioWBSAPIModelsChargingTableBaseVAT,
  RightioWBSAPIModelsChargingTablePostcodes,
  RightioWBSAPIModelsChargingTablePriceAdjustments,
  RightioWBSAPIModelsChargingTablePrices,
  RightioWBSAPIModelsChargingTableScheduleGroupSchedules,
  RightioWBSAPIModelsChargingTableScheduleGroups,
  RightioWBSAPIModelsCompletions,
  RightioWBSAPIModelsDiscountTypes,
  RightioWBSAPIModelsDiscounts,
  RightioWBSAPIModelsFailedReasons,
  RightioWBSAPIModelsGlobalSettings,
  RightioWBSAPIModelsJobBookingRestrictions,
  RightioWBSAPIModelsJobPatchInput,
  RightioWBSAPIModelsJobReviews,
  RightioWBSAPIModelsJobScripts,
  RightioWBSAPIModelsJobs,
  RightioWBSAPIModelsJobsInput,
  RightioWBSAPIModelsJobsLast,
  RightioWBSAPIModelsOtherPhoneCalls,
  RightioWBSAPIModelsPostcodeAreas,
  RightioWBSAPIModelsPostcodeGridReference,
  RightioWBSAPIModelsPostcodeGridReferenceInput,
  RightioWBSAPIModelsResponseTimes,
  RightioWBSAPIModelsResponseTimesInput,
  RightioWBSAPIModelsServiceAgreementBillingFrequency,
  RightioWBSAPIModelsServiceAgreementDeclinedReason,
  RightioWBSAPIModelsServiceAgreementDuration,
  RightioWBSAPIModelsServiceAgreementExcess,
  RightioWBSAPIModelsServiceAgreements,
  RightioWBSAPIModelsServiceAgreementsInfo,
  RightioWBSAPIModelsServiceAgreementsInfoInput,
  RightioWBSAPIModelsSettings,
  RightioWBSAPIModelsTablesAppointmentTimeTypes,
  RightioWBSAPIModelsTablesJobType,
  RightioWBSAPIModelsTablesJobTypeGroup,
  RightioWBSAPIModelsTablesTrade,
  RightioWBSAPIModelsTablesUsers,
  RightioWBSAPIModelsTablesUsersPatchInput,
  RightioWBSAPIModelsTimeRequirementTypeMatrix,
  RightioWBSAPIModelsTimeRequirementTypes,
  RightioWBSAPIModelsVATRates
} from '../../model';

import { customInstance } from '../../../../../services/DatabaseAccess/index';
import type { BodyType } from '../../../../../services/DatabaseAccess/index';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Retrieves all account code definitions including customer classifications, SLA targets, and pricing configurations.
 * @summary Get all Account Codes
 */
export const tablesAccountCodesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsAccountCodes[]>(
      {url: `/api/AccountCodes`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new account code definition for customer classification, pricing, and service level management.
 * @summary Create Account Code
 */
export const tablesAccountCodesCreate = (
    rightioWBSAPIModelsAccountCodes: BodyType<RightioWBSAPIModelsAccountCodes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsAccountCodes>(
      {url: `/api/AccountCodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsAccountCodes
    },
      options);
    }
  /**
 * Retrieves a specific account code by its ID including classification, SLA targets, and customer experience settings.
 * @summary Get Account Code by Id
 */
export const tablesAccountCodesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsAccountCodes>(
      {url: `/api/AccountCodes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing account code configuration including SLA targets, pricing, and customer experience settings.
 * @summary Update Account Code
 */
export const tablesAccountCodesUpdate = (
    id: number,
    rightioWBSAPIModelsAccountCodes: BodyType<RightioWBSAPIModelsAccountCodes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/AccountCodes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsAccountCodes
    },
      options);
    }
  /**
 * Permanently removes an account code from the system. Use with extreme caution as this affects historical data and customer relationships.
 * @summary Delete Account Code
 */
export const tablesAccountCodesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/AccountCodes/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves account code details using the customer-facing account code number for identification and verification.
 * @summary Get Account Code by Account Code
 */
export const tablesAccountCodesGetByAccountCode = (
    rightioWBSAPIModelsAccountCodesInput: BodyType<RightioWBSAPIModelsAccountCodesInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsAccountCodes>(
      {url: `/api/AccountCodes/byAccountCode`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsAccountCodesInput
    },
      options);
    }
  /**
 * Retrieves all address blacklist entries for service delivery risk management and engineer safety protection.
 * @summary Get all Address Blacklist
 */
export const tablesAddressBlacklistGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsAddressBlacklist[]>(
      {url: `/api/AddressBlacklist`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new address blacklist entry for service delivery risk management and engineer safety protection.
 * @summary Create Address Blacklist
 */
export const tablesAddressBlacklistCreate = (
    rightioWBSAPIModelsAddressBlacklist: BodyType<RightioWBSAPIModelsAddressBlacklist>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsAddressBlacklist>(
      {url: `/api/AddressBlacklist`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsAddressBlacklist
    },
      options);
    }
  /**
 * Retrieves a specific address blacklist entry by ID for detailed risk assessment and service delivery decision-making.
 * @summary Get Address Blacklist by Id
 */
export const tablesAddressBlacklistGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsAddressBlacklist>(
      {url: `/api/AddressBlacklist/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing address blacklist entry including property details, postcode, and restriction reasons.
 * @summary Update Address Blacklist
 */
export const tablesAddressBlacklistUpdate = (
    id: number,
    rightioWBSAPIModelsAddressBlacklist: BodyType<RightioWBSAPIModelsAddressBlacklist>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/AddressBlacklist/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsAddressBlacklist
    },
      options);
    }
  /**
 * Permanently removes an address blacklist entry from the system. Use with extreme caution as this affects engineer safety and business risk management.
 * @summary Delete Address Blacklist
 */
export const tablesAddressBlacklistDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/AddressBlacklist/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all application-specific configuration settings including environment customizations and feature flags.
 * @summary Get all Application Settings
 */
export const tablesApplicationSettingsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsApplicationSettings[]>(
      {url: `/api/ApplicationSettings`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new application-specific configuration setting for environment customization and feature control.
 * @summary Create Application Settings
 */
export const tablesApplicationSettingsCreate = (
    rightioWBSAPIModelsApplicationSettings: BodyType<RightioWBSAPIModelsApplicationSettings>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsApplicationSettings>(
      {url: `/api/ApplicationSettings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsApplicationSettings
    },
      options);
    }
  /**
 * Retrieves all configuration settings for a specific application instance including environment-specific customizations.
 * @summary Get Application Settings by Id
 */
export const tablesApplicationSettingsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsApplicationSettings>(
      {url: `/api/ApplicationSettings/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates application-specific configuration settings including environment customizations and feature flags.
 * @summary Update Application Settings
 */
export const tablesApplicationSettingsUpdate = (
    id: number,
    rightioWBSAPIModelsApplicationSettings: BodyType<RightioWBSAPIModelsApplicationSettings>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ApplicationSettings/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsApplicationSettings
    },
      options);
    }
  /**
 * Permanently removes application-specific configuration settings. Use with caution as this affects application behavior and functionality.
 * @summary Delete Application Settings
 */
export const tablesApplicationSettingsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ApplicationSettings/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all appointment time types for scheduling optimization and customer booking interface integration.
 * @summary Get all Appointment Time Types
 */
export const tablesAppointmentTimeTypesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesAppointmentTimeTypes[]>(
      {url: `/api/AppointmentTimeTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new appointment time type for expanding scheduling options and enhancing customer booking flexibility.
 * @summary Create Appointment Time Types
 */
export const tablesAppointmentTimeTypesCreate = (
    rightioWBSAPIModelsTablesAppointmentTimeTypes: BodyType<RightioWBSAPIModelsTablesAppointmentTimeTypes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesAppointmentTimeTypes>(
      {url: `/api/AppointmentTimeTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesAppointmentTimeTypes
    },
      options);
    }
  /**
 * Retrieves a specific appointment time type by ID for detailed scheduling parameter access and booking optimization.
 * @summary Get Appointment Time Types by Id
 */
export const tablesAppointmentTimeTypesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesAppointmentTimeTypes>(
      {url: `/api/AppointmentTimeTypes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing appointment time type including scheduling parameters, time boundaries, and service eligibility.
 * @summary Update Appointment Time Types
 */
export const tablesAppointmentTimeTypesUpdate = (
    id: number,
    rightioWBSAPIModelsTablesAppointmentTimeTypes: BodyType<RightioWBSAPIModelsTablesAppointmentTimeTypes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/AppointmentTimeTypes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesAppointmentTimeTypes
    },
      options);
    }
  /**
 * Permanently removes an appointment time type from the system. Use with caution as this affects customer booking options and scheduling efficiency.
 * @summary Delete Appointment Time Types
 */
export const tablesAppointmentTimeTypesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/AppointmentTimeTypes/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all phone number mapping configurations for call routing, tracking, and business intelligence.
 * @summary Get all Call Mapping
 */
export const tablesCallMappingGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCallMapping[]>(
      {url: `/api/CallMapping`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves call mapping configuration by source phone number for real-time routing and account assignment.
 * @summary Get Call Mapping by Source
 */
export const tablesCallMappingCreate = (
    rightioWBSAPIModelsCallMappingInput: BodyType<RightioWBSAPIModelsCallMappingInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCallMapping>(
      {url: `/api/CallMapping`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCallMappingInput
    },
      options);
    }
  /**
 * Retrieves all call center interaction records including timing, outcomes, agent information, and associated job bookings.
 * @summary Get all Calls
 */
export const tablesCallsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCalls[]>(
      {url: `/api/Calls`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new call record capturing interaction details, outcome, timing, and performance metrics.
 * @summary Create Calls
 */
export const tablesCallsCreate = (
    rightioWBSAPIModelsCalls: BodyType<RightioWBSAPIModelsCalls>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCalls>(
      {url: `/api/Calls`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCalls
    },
      options);
    }
  /**
 * Retrieves a specific call record by ID including all details about the interaction, outcome, and associated job.
 * @summary Get Calls by Id
 */
export const tablesCallsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCalls>(
      {url: `/api/Calls/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing call record with complete data including outcome, metrics, and job association.
 * @summary Update Calls
 */
export const tablesCallsUpdate = (
    id: number,
    rightioWBSAPIModelsCalls: BodyType<RightioWBSAPIModelsCalls>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Calls/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCalls
    },
      options);
    }
  /**
 * Partially updates specific fields of a call record without requiring the complete object.
 * @summary Patch Calls
 */
export const tablesCallsPatch = (
    id: number,
    rightioWBSAPIModelsCallsPatchInput: BodyType<RightioWBSAPIModelsCallsPatchInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCalls | void>(
      {url: `/api/Calls/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCallsPatchInput
    },
      options);
    }
  /**
 * Permanently removes a call record from the system. Use with caution as this affects metrics and audit trails.
 * @summary Delete Calls
 */
export const tablesCallsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Calls/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves the call record that created a specific job booking, useful for tracing job origins and quality reviews.
 * @summary Get Calls by JobId
 */
export const tablesCallsGetByJobId = (
    rightioWBSAPIModelsCallsInput: BodyType<RightioWBSAPIModelsCallsInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCalls>(
      {url: `/api/Calls/byJobId`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCallsInput
    },
      options);
    }
  /**
 * Retrieves all call type group associations for service categorization and workflow organization.
 * @summary Get all Call Type Groups
 */
export const tablesCallTypeGroupsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCallTypeGroups[]>(
      {url: `/api/CallTypeGroups`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new call type group association for service categorization and workflow organization.
 * @summary Create Call Type Groups
 */
export const tablesCallTypeGroupsCreate = (
    rightioWBSAPIModelsCallTypeGroups: BodyType<RightioWBSAPIModelsCallTypeGroups>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCallTypeGroups>(
      {url: `/api/CallTypeGroups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCallTypeGroups
    },
      options);
    }
  /**
 * Retrieves call type group associations by group identifier for workflow configuration and operational analysis.
 * @summary Get Call Type Groups by Id
 */
export const tablesCallTypeGroupsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCallTypeGroups>(
      {url: `/api/CallTypeGroups/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing call type group association including call type assignments and sequence ordering.
 * @summary Update Call Type Groups
 */
export const tablesCallTypeGroupsUpdate = (
    id: number,
    rightioWBSAPIModelsCallTypeGroups: BodyType<RightioWBSAPIModelsCallTypeGroups>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/CallTypeGroups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCallTypeGroups
    },
      options);
    }
  /**
 * Permanently removes a call type group association from the system. Use with caution as this affects workflow organization and reporting.
 * @summary Delete Call Type Groups
 */
export const tablesCallTypeGroupsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/CallTypeGroups/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all call type definitions for customer service categorization and agent script management.
 * @summary Get all Call Types
 */
export const tablesCallTypesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCallTypes[]>(
      {url: `/api/CallTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new call type definition for customer service categorization and agent guidance.
 * @summary Create Call Types
 */
export const tablesCallTypesCreate = (
    rightioWBSAPIModelsCallTypes: BodyType<RightioWBSAPIModelsCallTypes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCallTypes>(
      {url: `/api/CallTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCallTypes
    },
      options);
    }
  /**
 * Retrieves a specific call type definition by ID for agent guidance and workflow routing.
 * @summary Get Call Types by Id
 */
export const tablesCallTypesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCallTypes>(
      {url: `/api/CallTypes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing call type definition including scripts, terms, and classification flags.
 * @summary Update Call Types
 */
export const tablesCallTypesUpdate = (
    id: number,
    rightioWBSAPIModelsCallTypes: BodyType<RightioWBSAPIModelsCallTypes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/CallTypes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCallTypes
    },
      options);
    }
  /**
 * Permanently removes a call type definition from the system. Use with caution as this affects agent guidance and service categorization.
 * @summary Delete Call Types
 */
export const tablesCallTypesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/CallTypes/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all pricing charges including rates for different job types, postcodes, and charge types.
 * @summary Get all Charges
 */
export const tablesChargesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCharges[]>(
      {url: `/api/Charges`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new charge record defining pricing for a specific job type in a postcode area.
 * @summary Create Charges
 */
export const tablesChargesCreate = (
    rightioWBSAPIModelsCharges: BodyType<RightioWBSAPIModelsCharges>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCharges>(
      {url: `/api/Charges`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCharges
    },
      options);
    }
  /**
 * Retrieves a specific charge record by ID including job type, postcode area, and pricing details.
 * @summary Get Charges by Id
 */
export const tablesChargesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCharges>(
      {url: `/api/Charges/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing charge record including pricing amounts and time-based rate settings.
 * @summary Update Charges
 */
export const tablesChargesUpdate = (
    id: number,
    rightioWBSAPIModelsCharges: BodyType<RightioWBSAPIModelsCharges>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Charges/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCharges
    },
      options);
    }
  /**
 * Permanently removes a charge record from the pricing system. Use with caution as this affects pricing calculations.
 * @summary Delete Charges
 */
export const tablesChargesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Charges/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all charging table account code configurations for detailed customer identification and pricing specificity.
 * @summary Get all Charging Table Account Codes
 */
export const tablesChargingTableAccountCodesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableAccountCodes[]>(
      {url: `/api/ChargingTableAccountCodes`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific charging table account code by ID for detailed customer identification and pricing.
 * @summary Get Charging Table Account Code by Id
 */
export const tablesChargingTableAccountCodesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableAccountCodes>(
      {url: `/api/ChargingTableAccountCodes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all charging table account type configurations for customer classification and pricing differentiation.
 * @summary Get all Charging Table Account Types
 */
export const tablesChargingTableAccountTypesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableAccountTypes[]>(
      {url: `/api/ChargingTableAccountTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific charging table account type by ID for customer classification and pricing.
 * @summary Get Charging Table Account Type by Id
 */
export const tablesChargingTableAccountTypesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableAccountTypes>(
      {url: `/api/ChargingTableAccountTypes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all base charging table configurations for service pricing and revenue management optimization.
 * @summary Get all Charging Table Base
 */
export const tablesChargingTableBaseGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableBase[]>(
      {url: `/api/ChargingTableBase`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific base charging table configuration by ID for pricing calculation and quote generation.
 * @summary Get Charging Table Base by Id
 */
export const tablesChargingTableBaseGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableBase>(
      {url: `/api/ChargingTableBase/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all charging table base VAT configurations for tax calculation and pricing compliance.
 * @summary Get all Charging Table Base VAT
 */
export const tablesChargingTableBaseVATGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableBaseVAT[]>(
      {url: `/api/ChargingTableBaseVAT`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific charging table base VAT configuration by ID for tax calculation and compliance.
 * @summary Get Charging Table Base VAT by Id
 */
export const tablesChargingTableBaseVATGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableBaseVAT>(
      {url: `/api/ChargingTableBaseVAT/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all charging table postcode configurations for geographic pricing optimization and regional market positioning.
 * @summary Get all Charging Table Postcodes
 */
export const tablesChargingTablePostcodesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTablePostcodes[]>(
      {url: `/api/ChargingTablePostcodes`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific charging table postcode configuration by ID for geographic pricing calculation and regional analysis.
 * @summary Get Charging Table Postcodes by Id
 */
export const tablesChargingTablePostcodesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTablePostcodes>(
      {url: `/api/ChargingTablePostcodes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all charging table price adjustment configurations for dynamic pricing and revenue optimization.
 * @summary Get all Charging Table Price Adjustments
 */
export const tablesChargingTablePriceAdjustmentsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTablePriceAdjustments[]>(
      {url: `/api/ChargingTablePriceAdjustments`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific charging table price adjustment configuration by ID for dynamic pricing.
 * @summary Get Charging Table Price Adjustments by Id
 */
export const tablesChargingTablePriceAdjustmentsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTablePriceAdjustments>(
      {url: `/api/ChargingTablePriceAdjustments/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all charging table price configurations for job-specific pricing and quote generation optimization.
 * @summary Get all Charging Table Prices
 */
export const tablesChargingTablePricesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTablePrices[]>(
      {url: `/api/ChargingTablePrices`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific charging table price configuration by ID for pricing calculation and quote generation.
 * @summary Get Charging Table Prices by Id
 */
export const tablesChargingTablePricesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTablePrices>(
      {url: `/api/ChargingTablePrices/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all associations between schedule groups and schedules for managing complex time-based pricing rules and layered pricing strategies.
 * @summary Get all Charging Table Schedule Group Schedules
 */
export const tablesChargingTableScheduleGroupSchedulesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableScheduleGroupSchedules[]>(
      {url: `/api/ChargingTableScheduleGroupSchedules`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves specific schedule associations for a schedule group to view or modify time-based pricing rule assignments.
 * @summary Get Charging Table Schedule Group Schedules by Id
 */
export const tablesChargingTableScheduleGroupSchedulesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableScheduleGroupSchedules>(
      {url: `/api/ChargingTableScheduleGroupSchedules/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all pricing schedule groups for time-based service pricing configuration. Use this to manage peak/off-peak rates, weekend pricing, and seasonal variations.
 * @summary Get all Charging Table Schedule Groups
 */
export const tablesChargingTableScheduleGroupsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableScheduleGroups[]>(
      {url: `/api/ChargingTableScheduleGroups`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific pricing schedule group by ID to view or modify time-based pricing configurations for a particular pricing strategy.
 * @summary Get Charging Table Schedule Groups by Id
 */
export const tablesChargingTableScheduleGroupsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsChargingTableScheduleGroups>(
      {url: `/api/ChargingTableScheduleGroups/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves the final completion record for a specific job including work details, billing information, and payment collection.
 * @summary Get Completions by Job Id
 */
export const tablesCompletionsGetByJobId = (
    jobId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCompletions>(
      {url: `/api/Completions/${jobId}`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a comprehensive job completion record with work details, timing, billing, and payment information.
 * @summary Create Completions
 */
export const tablesCompletionsCreate = (
    rightioWBSAPIModelsCompletions: BodyType<RightioWBSAPIModelsCompletions>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsCompletions>(
      {url: `/api/Completions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsCompletions
    },
      options);
    }
  /**
 * Permanently removes a completion record from the system. Use with extreme caution as this affects billing, payroll, and compliance records.
 * @summary Delete Completions
 */
export const tablesCompletionsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Completions/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all discount definitions including codes, values, validity periods, and usage status.
 * @summary Get all Discounts
 */
export const tablesDiscountsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsDiscounts[]>(
      {url: `/api/Discounts`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new discount with code, value, type, validity period, and activation status.
 * @summary Create Discounts
 */
export const tablesDiscountsCreate = (
    rightioWBSAPIModelsDiscounts: BodyType<RightioWBSAPIModelsDiscounts>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsDiscounts>(
      {url: `/api/Discounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsDiscounts
    },
      options);
    }
  /**
 * Retrieves a specific discount by ID including code, value, type, and validity period.
 * @summary Get Discounts by Id
 */
export const tablesDiscountsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsDiscounts>(
      {url: `/api/Discounts/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing discount including code, value, validity period, and active status.
 * @summary Update Discounts
 */
export const tablesDiscountsUpdate = (
    id: number,
    rightioWBSAPIModelsDiscounts: BodyType<RightioWBSAPIModelsDiscounts>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Discounts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsDiscounts
    },
      options);
    }
  /**
 * Permanently removes a discount from the system. Use with caution as this affects historical data.
 * @summary Delete Discounts
 */
export const tablesDiscountsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Discounts/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all discount type associations showing which discounts apply to which categories.
 * @summary Get all DiscountTypes
 */
export const tablesDiscountTypesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsDiscountTypes[]>(
      {url: `/api/DiscountTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new association between a discount and a category type for targeted discount application.
 * @summary Create DiscountTypes
 */
export const tablesDiscountTypesCreate = (
    rightioWBSAPIModelsDiscountTypes: BodyType<RightioWBSAPIModelsDiscountTypes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsDiscountTypes>(
      {url: `/api/DiscountTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsDiscountTypes
    },
      options);
    }
  /**
 * Retrieves discount type associations for a specific type category ID.
 * @summary Get DiscountTypes by Id
 */
export const tablesDiscountTypesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsDiscountTypes>(
      {url: `/api/DiscountTypes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates a discount type association between a discount and a category.
 * @summary Update DiscountTypes
 */
export const tablesDiscountTypesUpdate = (
    id: number,
    rightioWBSAPIModelsDiscountTypes: BodyType<RightioWBSAPIModelsDiscountTypes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/DiscountTypes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsDiscountTypes
    },
      options);
    }
  /**
 * Removes a discount type association, preventing the discount from applying to that category.
 * @summary Delete DiscountTypes
 */
export const tablesDiscountTypesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/DiscountTypes/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all failure reason codes for job completion tracking, performance analysis, and system integration.
 * @summary Get all FailedReasons
 */
export const tablesFailedReasonsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsFailedReasons[]>(
      {url: `/api/FailedReasons`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new failure reason code for expanding job completion tracking and operational analysis capabilities.
 * @summary Create FailedReasons
 */
export const tablesFailedReasonsCreate = (
    rightioWBSAPIModelsFailedReasons: BodyType<RightioWBSAPIModelsFailedReasons>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsFailedReasons>(
      {url: `/api/FailedReasons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsFailedReasons
    },
      options);
    }
  /**
 * Retrieves a specific failure reason by ID for job completion tracking and performance analysis.
 * @summary Get FailedReasons by Id
 */
export const tablesFailedReasonsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsFailedReasons>(
      {url: `/api/FailedReasons/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing failure reason code including description, classification, and account associations.
 * @summary Update FailedReasons
 */
export const tablesFailedReasonsUpdate = (
    id: number,
    rightioWBSAPIModelsFailedReasons: BodyType<RightioWBSAPIModelsFailedReasons>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/FailedReasons/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsFailedReasons
    },
      options);
    }
  /**
 * Permanently removes a failure reason code from the system. Use with caution as this affects historical data and reporting accuracy.
 * @summary Delete FailedReasons
 */
export const tablesFailedReasonsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/FailedReasons/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all global system configuration settings including business rules, integration parameters, and feature flags.
 * @summary Get all GlobalSettings
 */
export const tablesGlobalSettingsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsGlobalSettings[]>(
      {url: `/api/GlobalSettings`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves a specific global configuration setting by its key for runtime configuration and business rule evaluation.
 * @summary Get GlobalSettings by Key
 */
export const tablesGlobalSettingsGetByKey = (
    key: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsGlobalSettings>(
      {url: `/api/GlobalSettings/${key}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all job booking restriction rules for scheduling constraint enforcement and resource optimization.
 * @summary Get all JobBookingRestrictions
 */
export const tablesJobBookingRestrictionsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobBookingRestrictions[]>(
      {url: `/api/JobBookingRestrictions`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new job booking restriction rule for scheduling constraint enforcement and operational optimization.
 * @summary Create JobBookingRestrictions
 */
export const tablesJobBookingRestrictionsCreate = (
    rightioWBSAPIModelsJobBookingRestrictions: BodyType<RightioWBSAPIModelsJobBookingRestrictions>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobBookingRestrictions>(
      {url: `/api/JobBookingRestrictions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobBookingRestrictions
    },
      options);
    }
  /**
 * Retrieves a specific job booking restriction by ID for constraint validation and scheduling optimization.
 * @summary Get JobBookingRestrictions by Id
 */
export const tablesJobBookingRestrictionsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobBookingRestrictions>(
      {url: `/api/JobBookingRestrictions/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing job booking restriction rule including targeting criteria, constraints, and enforcement logic.
 * @summary Update JobBookingRestrictions
 */
export const tablesJobBookingRestrictionsUpdate = (
    id: number,
    rightioWBSAPIModelsJobBookingRestrictions: BodyType<RightioWBSAPIModelsJobBookingRestrictions>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobBookingRestrictions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobBookingRestrictions
    },
      options);
    }
  /**
 * Permanently removes a job booking restriction rule from the system. Use with caution as this affects scheduling constraints and availability.
 * @summary Delete JobBookingRestrictions
 */
export const tablesJobBookingRestrictionsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobBookingRestrictions/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all customer job reviews for satisfaction analysis, quality assessment, and service improvement.
 * @summary Get all JobReviews
 */
export const tablesJobReviewsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobReviews[]>(
      {url: `/api/JobReviews`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new customer job review record for feedback collection and satisfaction tracking.
 * @summary Create JobReviews
 */
export const tablesJobReviewsCreate = (
    rightioWBSAPIModelsJobReviews: BodyType<RightioWBSAPIModelsJobReviews>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobReviews>(
      {url: `/api/JobReviews`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobReviews
    },
      options);
    }
  /**
 * Retrieves a specific job review by unique ID for detailed customer feedback analysis and service quality assessment.
 * @summary Get JobReviews by JobReviewId
 */
export const tablesJobReviewsGetById = (
    jobReviewId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobReviews>(
      {url: `/api/JobReviews/${jobReviewId}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing customer job review including satisfaction score, feedback comments, and completion tracking.
 * @summary Update JobReviews
 */
export const tablesJobReviewsUpdate = (
    id: string,
    rightioWBSAPIModelsJobReviews: BodyType<RightioWBSAPIModelsJobReviews>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobReviews/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobReviews
    },
      options);
    }
  /**
 * Permanently removes a customer job review from the system. Use with extreme caution as this affects satisfaction measurement and reporting accuracy.
 * @summary Delete JobReviews
 */
export const tablesJobReviewsDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobReviews/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves a completed customer review for a specific job, returning only finalized feedback with scores and comments.
 * @summary Get JobReviews by JobId
 */
export const tablesJobReviewsGetByJobId = (
    jobId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobReviews>(
      {url: `/api/JobReviews/${jobId}`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all job records from the database including complete customer information, scheduling details, and current status. Use with caution as this returns the entire dataset.
 * @summary Get all jobs
 */
export const jobsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobs[]>(
      {url: `/api/Jobs`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new job booking with customer details, service requirements, and scheduling preferences.
 * @summary Create a job
 */
export const jobsPostJob = (
    rightioWBSAPIModelsJobs: BodyType<NonReadonly<RightioWBSAPIModelsJobs>>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobs>(
      {url: `/api/Jobs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobs
    },
      options);
    }
  /**
 * Retrieves a single job record by its unique identifier, including all customer information, scheduling details, and current status.
 * @summary Get job by ID
 */
export const jobsGetById = (
    jobId: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobs>(
      {url: `/api/Jobs/${jobId}`, method: 'GET'
    },
      options);
    }
  /**
 * Searches for the last 2 jobs associated with a customer based on property address, phone numbers, or email. Useful for viewing customer history and previous work.
 * @summary Find recent jobs by customer details
 */
export const jobsFindRecentByCustomer = (
    rightioWBSAPIModelsJobsInput: BodyType<RightioWBSAPIModelsJobsInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobsLast[]>(
      {url: `/api/Jobs/last2`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobsInput
    },
      options);
    }
  /**
 * Retrieves the 2 most recent completed jobs associated with a mobile phone number for customer service and history tracking.
 * @summary Get last 2 jobs by mobile
 */
export const jobsGetLast2JobsByMobile = (
    rightioWBSAPIModelsJobsInput: BodyType<RightioWBSAPIModelsJobsInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobs[]>(
      {url: `/api/Jobs/last2by-mob`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobsInput
    },
      options);
    }
  /**
 * Retrieves the 2 most recent completed jobs associated with a landline phone number for property-based service history.
 * @summary Get last 2 jobs by landline
 */
export const jobsGetLast2JobsByLandline = (
    rightioWBSAPIModelsJobsInput: BodyType<RightioWBSAPIModelsJobsInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobs[]>(
      {url: `/api/Jobs/last2by-lan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobsInput
    },
      options);
    }
  /**
 * Updates an existing job record with new customer information, scheduling details, or status changes.
 * @summary Update a job
 */
export const jobsPutJobs = (
    id: number,
    rightioWBSAPIModelsJobs: BodyType<NonReadonly<RightioWBSAPIModelsJobs>>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Jobs/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobs
    },
      options);
    }
  /**
 * Partially updates a job record with only the specified fields, preserving all other existing data.
 * @summary Patch a job
 */
export const jobsPatchJob = (
    id: number,
    rightioWBSAPIModelsJobPatchInput: BodyType<RightioWBSAPIModelsJobPatchInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobs>(
      {url: `/api/Jobs/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobPatchInput
    },
      options);
    }
  /**
 * Permanently removes a job record from the system. Use with extreme caution as this affects service history and audit trails.
 * @summary Delete a job
 */
export const jobsDeleteJob = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Jobs/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all customer service scripts for call handling, training, and quality assurance.
 * @summary Get all JobScripts
 */
export const tablesJobScriptsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobScripts[]>(
      {url: `/api/JobScripts`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new customer service script for call handling, training, and quality assurance.
 * @summary Create JobScripts
 */
export const tablesJobScriptsCreate = (
    rightioWBSAPIModelsJobScripts: BodyType<RightioWBSAPIModelsJobScripts>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobScripts>(
      {url: `/api/JobScripts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobScripts
    },
      options);
    }
  /**
 * Retrieves a specific customer service script by ID for call handling, training, and quality assurance.
 * @summary Get JobScripts by Id
 */
export const tablesJobScriptsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsJobScripts>(
      {url: `/api/JobScripts/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing customer service script including content, targeting criteria, and service specifications.
 * @summary Update JobScripts
 */
export const tablesJobScriptsUpdate = (
    id: number,
    rightioWBSAPIModelsJobScripts: BodyType<RightioWBSAPIModelsJobScripts>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobScripts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsJobScripts
    },
      options);
    }
  /**
 * Permanently removes a customer service script from the system. Use with caution as this affects service quality and training.
 * @summary Delete JobScripts
 */
export const tablesJobScriptsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobScripts/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all job type groups used for categorizing work types within trades.
 * @summary Get all JobTypeGroups
 */
export const tablesJobTypeGroupsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesJobTypeGroup[]>(
      {url: `/api/JobTypeGroups`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new job type group for categorizing related job types.
 * @summary Create JobTypeGroup
 */
export const tablesJobTypeGroupsCreate = (
    rightioWBSAPIModelsTablesJobTypeGroup: BodyType<RightioWBSAPIModelsTablesJobTypeGroup>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesJobTypeGroup>(
      {url: `/api/JobTypeGroups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesJobTypeGroup
    },
      options);
    }
  /**
 * Retrieves a specific job type group by its single-character code.
 * @summary Get JobTypeGroup by Id
 */
export const tablesJobTypeGroupsGetById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesJobTypeGroup>(
      {url: `/api/JobTypeGroups/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing job type group's description and display order.
 * @summary Update JobTypeGroup
 */
export const tablesJobTypeGroupsUpdate = (
    id: string,
    rightioWBSAPIModelsTablesJobTypeGroup: BodyType<RightioWBSAPIModelsTablesJobTypeGroup>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobTypeGroups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesJobTypeGroup
    },
      options);
    }
  /**
 * Permanently removes a job type group from the system. Use with caution as this affects all related job types.
 * @summary Delete JobTypeGroup
 */
export const tablesJobTypeGroupsDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobTypeGroups/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all job type definitions including codes, descriptions, pricing rules, scripts, and compliance requirements.
 * @summary Get all JobTypes
 */
export const tablesJobTypesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesJobType[]>(
      {url: `/api/JobTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new job type definition with code, descriptions, pricing configuration, scripts, and compliance settings.
 * @summary Create JobType
 */
export const tablesJobTypesCreate = (
    rightioWBSAPIModelsTablesJobType: BodyType<RightioWBSAPIModelsTablesJobType>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesJobType>(
      {url: `/api/JobTypes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesJobType
    },
      options);
    }
  /**
 * Retrieves a specific job type by its code including all configuration, scripts, pricing rules, and compliance settings.
 * @summary Get JobType by Id
 */
export const tablesJobTypesGetById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesJobType>(
      {url: `/api/JobTypes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing job type's configuration including descriptions, pricing rules, scripts, and compliance settings.
 * @summary Update JobType
 */
export const tablesJobTypesUpdate = (
    id: string,
    rightioWBSAPIModelsTablesJobType: BodyType<RightioWBSAPIModelsTablesJobType>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobTypes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesJobType
    },
      options);
    }
  /**
 * Permanently removes a job type from the system. Use with caution as this affects jobs, pricing, and historical data.
 * @summary Delete JobType
 */
export const tablesJobTypesDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/JobTypes/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all non-booking phone call categories for customer service classification and call center operations.
 * @summary Get all OtherPhoneCalls
 */
export const tablesOtherPhoneCallsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsOtherPhoneCalls[]>(
      {url: `/api/OtherPhoneCalls`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new non-booking phone call category for customer service classification and call center operations.
 * @summary Create OtherPhoneCalls
 */
export const tablesOtherPhoneCallsCreate = (
    rightioWBSAPIModelsOtherPhoneCalls: BodyType<RightioWBSAPIModelsOtherPhoneCalls>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsOtherPhoneCalls>(
      {url: `/api/OtherPhoneCalls`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsOtherPhoneCalls
    },
      options);
    }
  /**
 * Retrieves a specific non-booking phone call category by ID for customer service classification and call handling guidance.
 * @summary Get OtherPhoneCalls by Id
 */
export const tablesOtherPhoneCallsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsOtherPhoneCalls>(
      {url: `/api/OtherPhoneCalls/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing non-booking phone call category including name, status, and guidance information.
 * @summary Update OtherPhoneCalls
 */
export const tablesOtherPhoneCallsUpdate = (
    id: number,
    rightioWBSAPIModelsOtherPhoneCalls: BodyType<RightioWBSAPIModelsOtherPhoneCalls>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/OtherPhoneCalls/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsOtherPhoneCalls
    },
      options);
    }
  /**
 * Permanently removes a non-booking phone call category from the system. Use with caution as this affects call classification and historical data.
 * @summary Delete OtherPhoneCalls
 */
export const tablesOtherPhoneCallsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/OtherPhoneCalls/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all postcode area definitions including coverage zones, commercial classifications, and business targets.
 * @summary Get all PostcodeAreas
 */
export const tablesPostcodeAreasGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPostcodeAreas[]>(
      {url: `/api/PostcodeAreas`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new postcode area definition for expanding service coverage into new geographic regions.
 * @summary Create PostcodeAreas
 */
export const tablesPostcodeAreasCreate = (
    rightioWBSAPIModelsPostcodeAreas: BodyType<RightioWBSAPIModelsPostcodeAreas>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPostcodeAreas>(
      {url: `/api/PostcodeAreas`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPostcodeAreas
    },
      options);
    }
  /**
 * Retrieves a specific postcode area by its code including zone classification and business targets.
 * @summary Get PostcodeAreas by Id
 */
export const tablesPostcodeAreasGetById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPostcodeAreas>(
      {url: `/api/PostcodeAreas/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing postcode area's configuration including zones, classifications, and targets.
 * @summary Update PostcodeAreas
 */
export const tablesPostcodeAreasUpdate = (
    id: string,
    rightioWBSAPIModelsPostcodeAreas: BodyType<RightioWBSAPIModelsPostcodeAreas>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/PostcodeAreas/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPostcodeAreas
    },
      options);
    }
  /**
 * Permanently removes a postcode area from service coverage. Use with caution as this affects all area-based operations.
 * @summary Delete PostcodeAreas
 */
export const tablesPostcodeAreasDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/PostcodeAreas/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves geographic data for a postcode district. Extracts the district portion from a full postcode and returns approximate coordinates for regional planning and coverage analysis.
 * @summary Get PostcodeDistrictGridReference
 */
export const postcodeDistrictGridReferenceGet = (
    rightioWBSAPIModelsPostcodeGridReferenceInput: BodyType<RightioWBSAPIModelsPostcodeGridReferenceInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPostcodeGridReference>(
      {url: `/api/PostcodeDistrictGridReference`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPostcodeGridReferenceInput
    },
      options);
    }
  /**
 * Retrieves geographic coordinates and grid reference data for a UK postcode. Returns detailed location information for service area validation and engineer dispatch optimization.
 * @summary Get PostcodeGridReference
 */
export const postcodeGridReferenceGet = (
    rightioWBSAPIModelsPostcodeGridReferenceInput: BodyType<RightioWBSAPIModelsPostcodeGridReferenceInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsPostcodeGridReference[]>(
      {url: `/api/PostcodeGridReference`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsPostcodeGridReferenceInput
    },
      options);
    }
  /**
 * Retrieves all response time targets for different trades across all postcode areas.
 * @summary Get all ResponseTimes
 */
export const tablesResponseTimesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsResponseTimes[]>(
      {url: `/api/ResponseTimes`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves response time targets for all trades in a specific postcode area.
 * @summary Get ResponseTimes by PostcodeArea
 */
export const tablesResponseTimesGetByArea = (
    rightioWBSAPIModelsResponseTimesInput: BodyType<RightioWBSAPIModelsResponseTimesInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsResponseTimes[]>(
      {url: `/api/ResponseTimes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsResponseTimesInput
    },
      options);
    }
  /**
 * Updates response time targets for trades in a specific postcode area.
 * @summary Update ResponseTimes
 */
export const tablesResponseTimesUpdate = (
    id: number,
    rightioWBSAPIModelsResponseTimes: BodyType<RightioWBSAPIModelsResponseTimes>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ResponseTimes/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsResponseTimes
    },
      options);
    }
  /**
 * Permanently removes response time targets for a specific area. Use with caution as this affects service commitments.
 * @summary Delete ResponseTimes
 */
export const tablesResponseTimesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ResponseTimes/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all service agreement billing frequency configurations for payment schedule management and customer convenience.
 * @summary Get all Billing Frequency
 */
export const tablesServiceAgreementBillingFrequencyGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementBillingFrequency[]>(
      {url: `/api/ServiceAgreementBillingFrequency`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new service agreement billing frequency for payment schedule management.
 * @summary Create Billing Frequency
 */
export const tablesServiceAgreementBillingFrequencyCreate = (
    rightioWBSAPIModelsServiceAgreementBillingFrequency: BodyType<RightioWBSAPIModelsServiceAgreementBillingFrequency>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementBillingFrequency>(
      {url: `/api/ServiceAgreementBillingFrequency`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreementBillingFrequency
    },
      options);
    }
  /**
 * Retrieves a specific service agreement billing frequency by ID for payment schedule configuration.
 * @summary Get Billing Frequency by Id
 */
export const tablesServiceAgreementBillingFrequencyGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementBillingFrequency>(
      {url: `/api/ServiceAgreementBillingFrequency/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing service agreement billing frequency for payment schedule management.
 * @summary Update Billing Frequency
 */
export const tablesServiceAgreementBillingFrequencyUpdate = (
    id: number,
    rightioWBSAPIModelsServiceAgreementBillingFrequency: BodyType<RightioWBSAPIModelsServiceAgreementBillingFrequency>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ServiceAgreementBillingFrequency/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreementBillingFrequency
    },
      options);
    }
  /**
 * Permanently removes a service agreement billing frequency from the system.
 * @summary Delete Billing Frequency
 */
export const tablesServiceAgreementBillingFrequencyDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ServiceAgreementBillingFrequency/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all service agreement declined reason configurations for sales tracking and customer analysis.
 * @summary Get all Service Agreement Declined Reasons
 */
export const tablesServiceAgreementDeclinedReasonGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementDeclinedReason[]>(
      {url: `/api/ServiceAgreementDeclinedReason`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all service agreement duration configurations for contract term management and customer options.
 * @summary Get all Service Agreement Durations
 */
export const tablesServiceAgreementDurationGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementDuration[]>(
      {url: `/api/ServiceAgreementDuration`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new service agreement duration configuration for contract term options.
 * @summary Create Service Agreement Duration
 */
export const tablesServiceAgreementDurationCreate = (
    rightioWBSAPIModelsServiceAgreementDuration: BodyType<RightioWBSAPIModelsServiceAgreementDuration>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementDuration>(
      {url: `/api/ServiceAgreementDuration`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreementDuration
    },
      options);
    }
  /**
 * Retrieves a specific service agreement duration by ID for contract term details.
 * @summary Get Service Agreement Duration by Id
 */
export const tablesServiceAgreementDurationGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementDuration>(
      {url: `/api/ServiceAgreementDuration/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing service agreement duration configuration for contract term management.
 * @summary Update Service Agreement Duration
 */
export const tablesServiceAgreementDurationUpdate = (
    id: number,
    rightioWBSAPIModelsServiceAgreementDuration: BodyType<RightioWBSAPIModelsServiceAgreementDuration>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ServiceAgreementDuration/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreementDuration
    },
      options);
    }
  /**
 * Permanently removes a service agreement duration from the system.
 * @summary Delete Service Agreement Duration
 */
export const tablesServiceAgreementDurationDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ServiceAgreementDuration/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all service agreement excess configurations for cost-sharing and service call charges.
 * @summary Get all Service Agreement Excess Options
 */
export const tablesServiceAgreementExcessGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementExcess[]>(
      {url: `/api/ServiceAgreementExcess`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new service agreement excess configuration for cost-sharing options.
 * @summary Create Service Agreement Excess
 */
export const tablesServiceAgreementExcessCreate = (
    rightioWBSAPIModelsServiceAgreementExcess: BodyType<RightioWBSAPIModelsServiceAgreementExcess>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementExcess>(
      {url: `/api/ServiceAgreementExcess`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreementExcess
    },
      options);
    }
  /**
 * Retrieves a specific service agreement excess by ID for cost-sharing details.
 * @summary Get Service Agreement Excess by Id
 */
export const tablesServiceAgreementExcessGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementExcess>(
      {url: `/api/ServiceAgreementExcess/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing service agreement excess configuration for cost-sharing management.
 * @summary Update Service Agreement Excess
 */
export const tablesServiceAgreementExcessUpdate = (
    id: number,
    rightioWBSAPIModelsServiceAgreementExcess: BodyType<RightioWBSAPIModelsServiceAgreementExcess>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ServiceAgreementExcess/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreementExcess
    },
      options);
    }
  /**
 * Permanently removes a service agreement excess configuration from the system.
 * @summary Delete Service Agreement Excess
 */
export const tablesServiceAgreementExcessDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ServiceAgreementExcess/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all service agreement records from the system with complete contract details, customer relationships, and current status. Used for administrative purposes and bulk data operations.
 * @summary Get all ServiceAgreements
 */
export const tablesServiceAgreementsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreements[]>(
      {url: `/api/ServiceAgreements`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new service agreement contract with comprehensive details including customer associations, contract terms, pricing structure, and service specifications.
 * @summary Create ServiceAgreements
 */
export const tablesServiceAgreementsCreate = (
    rightioWBSAPIModelsServiceAgreements: BodyType<RightioWBSAPIModelsServiceAgreements>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreements>(
      {url: `/api/ServiceAgreements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreements
    },
      options);
    }
  /**
 * Retrieves a specific service agreement by its unique identifier with complete contract details, customer information, pricing, and current status.
 * @summary Get ServiceAgreements by Id
 */
export const tablesServiceAgreementsGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreements>(
      {url: `/api/ServiceAgreements/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing service agreement with new contract details including terms, pricing, customer information, and service specifications. Handles concurrency conflicts gracefully.
 * @summary Update ServiceAgreements
 */
export const tablesServiceAgreementsUpdate = (
    id: number,
    rightioWBSAPIModelsServiceAgreements: BodyType<RightioWBSAPIModelsServiceAgreements>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ServiceAgreements/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreements
    },
      options);
    }
  /**
 * Permanently removes a service agreement from the system. Use with caution as this may affect related records. Consider status updates instead of deletion for data integrity.
 * @summary Delete ServiceAgreements
 */
export const tablesServiceAgreementsDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/ServiceAgreements/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves active service agreement information for a specific customer including type, status, and renewal details with related entity information.
 * @summary Get ServiceAgreements Information by Customer Id
 */
export const tablesServiceAgreementsGetInfoById = (
    rightioWBSAPIModelsServiceAgreementsInfoInput: BodyType<RightioWBSAPIModelsServiceAgreementsInfoInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsServiceAgreementsInfo>(
      {url: `/api/ServiceAgreements/info`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsServiceAgreementsInfoInput
    },
      options);
    }
  /**
 * Retrieves all setting definitions from the configuration schema including metadata and validation rules.
 * @summary Get all Settings
 */
export const tablesSettingsGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSettings[]>(
      {url: `/api/Settings`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new setting definition in the configuration schema for establishing new configuration parameters.
 * @summary Create Settings
 */
export const tablesSettingsCreate = (
    rightioWBSAPIModelsSettings: BodyType<RightioWBSAPIModelsSettings>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSettings>(
      {url: `/api/Settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSettings
    },
      options);
    }
  /**
 * Retrieves a specific setting definition by its key including metadata, validation rules, and configuration relationships.
 * @summary Get Settings by Id
 */
export const tablesSettingsGetById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsSettings>(
      {url: `/api/Settings/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing setting definition including description, validation rules, and administrative metadata.
 * @summary Update Settings
 */
export const tablesSettingsUpdate = (
    id: string,
    rightioWBSAPIModelsSettings: BodyType<RightioWBSAPIModelsSettings>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Settings/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsSettings
    },
      options);
    }
  /**
 * Permanently removes a setting definition from the configuration schema. Use with extreme caution as this affects all related configuration values.
 * @summary Delete Settings
 */
export const tablesSettingsDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Settings/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all time requirement type matrix mappings for account-specific service duration planning and resource allocation.
 * @summary Get all TimeRequirementTypeMatrix
 */
export const tablesTimeRequirementTypeMatrixGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTimeRequirementTypeMatrix[]>(
      {url: `/api/TimeRequirementTypeMatrix`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all time requirement type definitions for service scheduling and resource planning optimization.
 * @summary Get all TimeRequirementTypes
 */
export const tablesTimeRequirementTypesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTimeRequirementTypes[]>(
      {url: `/api/TimeRequirementTypes`, method: 'GET'
    },
      options);
    }
  /**
 * Retrieves all trade categories including codes, descriptions, display properties, and website visibility settings.
 * @summary Get all Trades
 */
export const tablesTradesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesTrade[]>(
      {url: `/api/Trades`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new trade category with unique code, description, display properties, and configuration settings.
 * @summary Create a Trade
 */
export const tablesTradesCreate = (
    rightioWBSAPIModelsTablesTrade: BodyType<RightioWBSAPIModelsTablesTrade>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesTrade>(
      {url: `/api/Trades`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesTrade
    },
      options);
    }
  /**
 * Retrieves a specific trade by its single-character code including description, display properties, and settings.
 * @summary Get a Trade by Id
 */
export const tablesTradesGetById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesTrade>(
      {url: `/api/Trades/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing trade's properties including description, display color, sort order, and visibility settings.
 * @summary Update a Trade
 */
export const tablesTradesUpdate = (
    id: string,
    rightioWBSAPIModelsTablesTrade: BodyType<RightioWBSAPIModelsTablesTrade>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Trades/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesTrade
    },
      options);
    }
  /**
 * Permanently removes a trade category from the system. Use with caution as this affects all related data.
 * @summary Delete a Trade
 */
export const tablesTradesDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Trades/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all system users including agents, engineers, managers, and administrators with their complete profile information, roles, and permissions.
 * @summary Get all Users
 */
export const tablesUsersGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesUsers[]>(
      {url: `/api/Users`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new system user account with authentication credentials, profile information, role assignments, and initial preferences.
 * @summary Create Users
 */
export const tablesUsersCreate = (
    rightioWBSAPIModelsTablesUsers: BodyType<RightioWBSAPIModelsTablesUsers>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesUsers>(
      {url: `/api/Users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesUsers
    },
      options);
    }
  /**
 * Retrieves a specific user by their unique identifier including all profile information, roles, permissions, and system settings.
 * @summary Get Users by Id
 */
export const tablesUsersGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesUsers>(
      {url: `/api/Users/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing user's complete profile including personal information, credentials, roles, permissions, and system settings.
 * @summary Update Users
 */
export const tablesUsersUpdate = (
    id: number,
    rightioWBSAPIModelsTablesUsers: BodyType<RightioWBSAPIModelsTablesUsers>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesUsers
    },
      options);
    }
  /**
 * Updates specific user fields without requiring the complete user object. Currently supports updating AutoBooking preference.
 * @summary Partially update Users
 */
export const tablesUsersPatch = (
    id: number,
    rightioWBSAPIModelsTablesUsersPatchInput: BodyType<RightioWBSAPIModelsTablesUsersPatchInput>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsTablesUsers | void>(
      {url: `/api/Users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsTablesUsersPatchInput
    },
      options);
    }
  /**
 * Permanently removes a user from the system. Use with caution as this affects historical data. Consider deactivation instead.
 * @summary Delete Users
 */
export const tablesUsersDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/Users/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieves all VAT rate definitions including current and historical rates for tax calculations and compliance.
 * @summary Get all VATRates
 */
export const tablesVATRatesGetAll = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsVATRates[]>(
      {url: `/api/VATRates`, method: 'GET'
    },
      options);
    }
  /**
 * Creates a new VAT rate definition for tax calculations and compliance. Coordinate with finance team before activation.
 * @summary Create VATRates
 */
export const tablesVATRatesCreate = (
    rightioWBSAPIModelsVATRates: BodyType<RightioWBSAPIModelsVATRates>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsVATRates>(
      {url: `/api/VATRates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsVATRates
    },
      options);
    }
  /**
 * Retrieves a specific VAT rate by its version ID for tax calculations and compliance verification.
 * @summary Get VATRates by Id
 */
export const tablesVATRatesGetById = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioWBSAPIModelsVATRates>(
      {url: `/api/VATRates/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * Updates an existing VAT rate configuration. Use with caution as changes affect tax calculations and compliance.
 * @summary Update VATRates
 */
export const tablesVATRatesUpdate = (
    id: number,
    rightioWBSAPIModelsVATRates: BodyType<RightioWBSAPIModelsVATRates>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/VATRates/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rightioWBSAPIModelsVATRates
    },
      options);
    }
  /**
 * Permanently removes a VAT rate from the system. Use with extreme caution as this affects tax compliance and audit trails.
 * @summary Delete VATRates
 */
export const tablesVATRatesDelete = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/api/VATRates/${id}`, method: 'DELETE'
    },
      options);
    }
  export type TablesAccountCodesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesAccountCodesGetAll>>>
export type TablesAccountCodesCreateResult = NonNullable<Awaited<ReturnType<typeof tablesAccountCodesCreate>>>
export type TablesAccountCodesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesAccountCodesGetById>>>
export type TablesAccountCodesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesAccountCodesUpdate>>>
export type TablesAccountCodesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesAccountCodesDelete>>>
export type TablesAccountCodesGetByAccountCodeResult = NonNullable<Awaited<ReturnType<typeof tablesAccountCodesGetByAccountCode>>>
export type TablesAddressBlacklistGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesAddressBlacklistGetAll>>>
export type TablesAddressBlacklistCreateResult = NonNullable<Awaited<ReturnType<typeof tablesAddressBlacklistCreate>>>
export type TablesAddressBlacklistGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesAddressBlacklistGetById>>>
export type TablesAddressBlacklistUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesAddressBlacklistUpdate>>>
export type TablesAddressBlacklistDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesAddressBlacklistDelete>>>
export type TablesApplicationSettingsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesApplicationSettingsGetAll>>>
export type TablesApplicationSettingsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesApplicationSettingsCreate>>>
export type TablesApplicationSettingsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesApplicationSettingsGetById>>>
export type TablesApplicationSettingsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesApplicationSettingsUpdate>>>
export type TablesApplicationSettingsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesApplicationSettingsDelete>>>
export type TablesAppointmentTimeTypesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesAppointmentTimeTypesGetAll>>>
export type TablesAppointmentTimeTypesCreateResult = NonNullable<Awaited<ReturnType<typeof tablesAppointmentTimeTypesCreate>>>
export type TablesAppointmentTimeTypesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesAppointmentTimeTypesGetById>>>
export type TablesAppointmentTimeTypesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesAppointmentTimeTypesUpdate>>>
export type TablesAppointmentTimeTypesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesAppointmentTimeTypesDelete>>>
export type TablesCallMappingGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesCallMappingGetAll>>>
export type TablesCallMappingCreateResult = NonNullable<Awaited<ReturnType<typeof tablesCallMappingCreate>>>
export type TablesCallsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesCallsGetAll>>>
export type TablesCallsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesCallsCreate>>>
export type TablesCallsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesCallsGetById>>>
export type TablesCallsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesCallsUpdate>>>
export type TablesCallsPatchResult = NonNullable<Awaited<ReturnType<typeof tablesCallsPatch>>>
export type TablesCallsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesCallsDelete>>>
export type TablesCallsGetByJobIdResult = NonNullable<Awaited<ReturnType<typeof tablesCallsGetByJobId>>>
export type TablesCallTypeGroupsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypeGroupsGetAll>>>
export type TablesCallTypeGroupsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypeGroupsCreate>>>
export type TablesCallTypeGroupsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypeGroupsGetById>>>
export type TablesCallTypeGroupsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypeGroupsUpdate>>>
export type TablesCallTypeGroupsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypeGroupsDelete>>>
export type TablesCallTypesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypesGetAll>>>
export type TablesCallTypesCreateResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypesCreate>>>
export type TablesCallTypesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypesGetById>>>
export type TablesCallTypesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypesUpdate>>>
export type TablesCallTypesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesCallTypesDelete>>>
export type TablesChargesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargesGetAll>>>
export type TablesChargesCreateResult = NonNullable<Awaited<ReturnType<typeof tablesChargesCreate>>>
export type TablesChargesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargesGetById>>>
export type TablesChargesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesChargesUpdate>>>
export type TablesChargesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesChargesDelete>>>
export type TablesChargingTableAccountCodesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableAccountCodesGetAll>>>
export type TablesChargingTableAccountCodesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableAccountCodesGetById>>>
export type TablesChargingTableAccountTypesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableAccountTypesGetAll>>>
export type TablesChargingTableAccountTypesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableAccountTypesGetById>>>
export type TablesChargingTableBaseGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableBaseGetAll>>>
export type TablesChargingTableBaseGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableBaseGetById>>>
export type TablesChargingTableBaseVATGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableBaseVATGetAll>>>
export type TablesChargingTableBaseVATGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableBaseVATGetById>>>
export type TablesChargingTablePostcodesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTablePostcodesGetAll>>>
export type TablesChargingTablePostcodesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTablePostcodesGetById>>>
export type TablesChargingTablePriceAdjustmentsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTablePriceAdjustmentsGetAll>>>
export type TablesChargingTablePriceAdjustmentsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTablePriceAdjustmentsGetById>>>
export type TablesChargingTablePricesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTablePricesGetAll>>>
export type TablesChargingTablePricesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTablePricesGetById>>>
export type TablesChargingTableScheduleGroupSchedulesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableScheduleGroupSchedulesGetAll>>>
export type TablesChargingTableScheduleGroupSchedulesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableScheduleGroupSchedulesGetById>>>
export type TablesChargingTableScheduleGroupsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableScheduleGroupsGetAll>>>
export type TablesChargingTableScheduleGroupsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesChargingTableScheduleGroupsGetById>>>
export type TablesCompletionsGetByJobIdResult = NonNullable<Awaited<ReturnType<typeof tablesCompletionsGetByJobId>>>
export type TablesCompletionsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesCompletionsCreate>>>
export type TablesCompletionsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesCompletionsDelete>>>
export type TablesDiscountsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountsGetAll>>>
export type TablesDiscountsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountsCreate>>>
export type TablesDiscountsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountsGetById>>>
export type TablesDiscountsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountsUpdate>>>
export type TablesDiscountsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountsDelete>>>
export type TablesDiscountTypesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountTypesGetAll>>>
export type TablesDiscountTypesCreateResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountTypesCreate>>>
export type TablesDiscountTypesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountTypesGetById>>>
export type TablesDiscountTypesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountTypesUpdate>>>
export type TablesDiscountTypesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesDiscountTypesDelete>>>
export type TablesFailedReasonsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesFailedReasonsGetAll>>>
export type TablesFailedReasonsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesFailedReasonsCreate>>>
export type TablesFailedReasonsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesFailedReasonsGetById>>>
export type TablesFailedReasonsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesFailedReasonsUpdate>>>
export type TablesFailedReasonsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesFailedReasonsDelete>>>
export type TablesGlobalSettingsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesGlobalSettingsGetAll>>>
export type TablesGlobalSettingsGetByKeyResult = NonNullable<Awaited<ReturnType<typeof tablesGlobalSettingsGetByKey>>>
export type TablesJobBookingRestrictionsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesJobBookingRestrictionsGetAll>>>
export type TablesJobBookingRestrictionsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesJobBookingRestrictionsCreate>>>
export type TablesJobBookingRestrictionsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesJobBookingRestrictionsGetById>>>
export type TablesJobBookingRestrictionsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesJobBookingRestrictionsUpdate>>>
export type TablesJobBookingRestrictionsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesJobBookingRestrictionsDelete>>>
export type TablesJobReviewsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesJobReviewsGetAll>>>
export type TablesJobReviewsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesJobReviewsCreate>>>
export type TablesJobReviewsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesJobReviewsGetById>>>
export type TablesJobReviewsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesJobReviewsUpdate>>>
export type TablesJobReviewsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesJobReviewsDelete>>>
export type TablesJobReviewsGetByJobIdResult = NonNullable<Awaited<ReturnType<typeof tablesJobReviewsGetByJobId>>>
export type JobsGetAllResult = NonNullable<Awaited<ReturnType<typeof jobsGetAll>>>
export type JobsPostJobResult = NonNullable<Awaited<ReturnType<typeof jobsPostJob>>>
export type JobsGetByIdResult = NonNullable<Awaited<ReturnType<typeof jobsGetById>>>
export type JobsFindRecentByCustomerResult = NonNullable<Awaited<ReturnType<typeof jobsFindRecentByCustomer>>>
export type JobsGetLast2JobsByMobileResult = NonNullable<Awaited<ReturnType<typeof jobsGetLast2JobsByMobile>>>
export type JobsGetLast2JobsByLandlineResult = NonNullable<Awaited<ReturnType<typeof jobsGetLast2JobsByLandline>>>
export type JobsPutJobsResult = NonNullable<Awaited<ReturnType<typeof jobsPutJobs>>>
export type JobsPatchJobResult = NonNullable<Awaited<ReturnType<typeof jobsPatchJob>>>
export type JobsDeleteJobResult = NonNullable<Awaited<ReturnType<typeof jobsDeleteJob>>>
export type TablesJobScriptsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesJobScriptsGetAll>>>
export type TablesJobScriptsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesJobScriptsCreate>>>
export type TablesJobScriptsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesJobScriptsGetById>>>
export type TablesJobScriptsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesJobScriptsUpdate>>>
export type TablesJobScriptsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesJobScriptsDelete>>>
export type TablesJobTypeGroupsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypeGroupsGetAll>>>
export type TablesJobTypeGroupsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypeGroupsCreate>>>
export type TablesJobTypeGroupsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypeGroupsGetById>>>
export type TablesJobTypeGroupsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypeGroupsUpdate>>>
export type TablesJobTypeGroupsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypeGroupsDelete>>>
export type TablesJobTypesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypesGetAll>>>
export type TablesJobTypesCreateResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypesCreate>>>
export type TablesJobTypesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypesGetById>>>
export type TablesJobTypesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypesUpdate>>>
export type TablesJobTypesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesJobTypesDelete>>>
export type TablesOtherPhoneCallsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesOtherPhoneCallsGetAll>>>
export type TablesOtherPhoneCallsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesOtherPhoneCallsCreate>>>
export type TablesOtherPhoneCallsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesOtherPhoneCallsGetById>>>
export type TablesOtherPhoneCallsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesOtherPhoneCallsUpdate>>>
export type TablesOtherPhoneCallsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesOtherPhoneCallsDelete>>>
export type TablesPostcodeAreasGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesPostcodeAreasGetAll>>>
export type TablesPostcodeAreasCreateResult = NonNullable<Awaited<ReturnType<typeof tablesPostcodeAreasCreate>>>
export type TablesPostcodeAreasGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesPostcodeAreasGetById>>>
export type TablesPostcodeAreasUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesPostcodeAreasUpdate>>>
export type TablesPostcodeAreasDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesPostcodeAreasDelete>>>
export type PostcodeDistrictGridReferenceGetResult = NonNullable<Awaited<ReturnType<typeof postcodeDistrictGridReferenceGet>>>
export type PostcodeGridReferenceGetResult = NonNullable<Awaited<ReturnType<typeof postcodeGridReferenceGet>>>
export type TablesResponseTimesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesResponseTimesGetAll>>>
export type TablesResponseTimesGetByAreaResult = NonNullable<Awaited<ReturnType<typeof tablesResponseTimesGetByArea>>>
export type TablesResponseTimesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesResponseTimesUpdate>>>
export type TablesResponseTimesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesResponseTimesDelete>>>
export type TablesServiceAgreementBillingFrequencyGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementBillingFrequencyGetAll>>>
export type TablesServiceAgreementBillingFrequencyCreateResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementBillingFrequencyCreate>>>
export type TablesServiceAgreementBillingFrequencyGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementBillingFrequencyGetById>>>
export type TablesServiceAgreementBillingFrequencyUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementBillingFrequencyUpdate>>>
export type TablesServiceAgreementBillingFrequencyDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementBillingFrequencyDelete>>>
export type TablesServiceAgreementDeclinedReasonGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementDeclinedReasonGetAll>>>
export type TablesServiceAgreementDurationGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementDurationGetAll>>>
export type TablesServiceAgreementDurationCreateResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementDurationCreate>>>
export type TablesServiceAgreementDurationGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementDurationGetById>>>
export type TablesServiceAgreementDurationUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementDurationUpdate>>>
export type TablesServiceAgreementDurationDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementDurationDelete>>>
export type TablesServiceAgreementExcessGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementExcessGetAll>>>
export type TablesServiceAgreementExcessCreateResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementExcessCreate>>>
export type TablesServiceAgreementExcessGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementExcessGetById>>>
export type TablesServiceAgreementExcessUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementExcessUpdate>>>
export type TablesServiceAgreementExcessDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementExcessDelete>>>
export type TablesServiceAgreementsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementsGetAll>>>
export type TablesServiceAgreementsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementsCreate>>>
export type TablesServiceAgreementsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementsGetById>>>
export type TablesServiceAgreementsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementsUpdate>>>
export type TablesServiceAgreementsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementsDelete>>>
export type TablesServiceAgreementsGetInfoByIdResult = NonNullable<Awaited<ReturnType<typeof tablesServiceAgreementsGetInfoById>>>
export type TablesSettingsGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesSettingsGetAll>>>
export type TablesSettingsCreateResult = NonNullable<Awaited<ReturnType<typeof tablesSettingsCreate>>>
export type TablesSettingsGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesSettingsGetById>>>
export type TablesSettingsUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesSettingsUpdate>>>
export type TablesSettingsDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesSettingsDelete>>>
export type TablesTimeRequirementTypeMatrixGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesTimeRequirementTypeMatrixGetAll>>>
export type TablesTimeRequirementTypesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesTimeRequirementTypesGetAll>>>
export type TablesTradesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesTradesGetAll>>>
export type TablesTradesCreateResult = NonNullable<Awaited<ReturnType<typeof tablesTradesCreate>>>
export type TablesTradesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesTradesGetById>>>
export type TablesTradesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesTradesUpdate>>>
export type TablesTradesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesTradesDelete>>>
export type TablesUsersGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesUsersGetAll>>>
export type TablesUsersCreateResult = NonNullable<Awaited<ReturnType<typeof tablesUsersCreate>>>
export type TablesUsersGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesUsersGetById>>>
export type TablesUsersUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesUsersUpdate>>>
export type TablesUsersPatchResult = NonNullable<Awaited<ReturnType<typeof tablesUsersPatch>>>
export type TablesUsersDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesUsersDelete>>>
export type TablesVATRatesGetAllResult = NonNullable<Awaited<ReturnType<typeof tablesVATRatesGetAll>>>
export type TablesVATRatesCreateResult = NonNullable<Awaited<ReturnType<typeof tablesVATRatesCreate>>>
export type TablesVATRatesGetByIdResult = NonNullable<Awaited<ReturnType<typeof tablesVATRatesGetById>>>
export type TablesVATRatesUpdateResult = NonNullable<Awaited<ReturnType<typeof tablesVATRatesUpdate>>>
export type TablesVATRatesDeleteResult = NonNullable<Awaited<ReturnType<typeof tablesVATRatesDelete>>>
